import { motion } from "framer-motion";
import ChapterHeader from "./ChapterHeader";
import { CONTENT } from "../data/content";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative border-t border-border py-24 md:py-40"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <ChapterHeader n="01" kicker="About" title={<>Who&nbsp;is<br /><span className="text-accent">Madan</span>.</>}>
          <div className="space-y-6 text-base md:text-lg leading-relaxed text-foreground/85 max-w-[62ch]">
            {CONTENT.about.body.map((p, i) => (
              <motion.p
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-10%" }}
                transition={{ duration: 0.6, delay: i * 0.05, ease: [0.16, 1, 0.3, 1] }}
              >
                {p}
              </motion.p>
            ))}
          </div>

          <div className="mt-14 md:mt-20 grid grid-cols-2 md:grid-cols-4 gap-px bg-border">
            {CONTENT.about.stats.map((s, i) => (
              <motion.div
                key={s.label}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-10%" }}
                transition={{ duration: 0.5, delay: i * 0.06 }}
                className="bg-background p-6 md:p-8"
                data-testid={`about-stat-${i}`}
              >
                <div className="font-heading text-4xl md:text-6xl font-black tracking-tighter text-accent">
                  {s.value}
                </div>
                <div className="mt-2 font-mono text-[10px] md:text-xs uppercase tracking-[0.2em] text-muted-foreground">
                  {s.label}
                </div>
              </motion.div>
            ))}
          </div>
        </ChapterHeader>
      </div>
    </section>
  );
}
